import { jsonrepair } from 'jsonrepair';

/**
 * Safely parse JSON with automatic repair using jsonrepair library
 * @param jsonString - The JSON string to parse
 * @param context - Optional context for error logging
 * @returns Parsed JSON object
 * @throws Error if parsing fails even after repair attempt
 */
export function safeJsonParse<T>(jsonString: string, _context?: string): T {
  try {
    // First try to parse as valid JSON
    return JSON.parse(jsonString);
  } catch (parseError) {
    // If regular JSON parsing fails, try to repair the JSON

    try {
      const repairedJson = jsonrepair(jsonString);
      const result = JSON.parse(repairedJson);
      return result;
    } catch (repairError) {
      return {} as T;
    }
  }
}

/**
 * Parse widget configuration with automatic JSON repair
 * @param configString - The widget configuration JSON string
 * @returns Parsed widget configuration
 */
export function parseWidgetConfig<T>(configString: string): T {
  return safeJsonParse<T>(configString, 'widget config');
}

/**
 * Parse dashboard configuration with automatic JSON repair
 * @param configString - The dashboard configuration JSON string
 * @returns Parsed dashboard configuration
 */
export function parseDashboardConfig<T>(configString: string): T {
  return safeJsonParse<T>(configString, 'dashboard config');
}
